import { selectedNavigationAtom } from '@/atoms/navigation';
import { NavigationItem } from '@/types/navigation';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useVideoPlaylistNavigationItem } from './useVideoPlaylistNavigationItem';
import { usePlayerNavigationItem } from './usePlayerNavigationItem';
import { useTeamNavigationItem } from './useTeamNavigationItem';
import { useKeeperNavigationItem } from './useKeeperNavigationItem';
import { useMatchNavigationItem } from './useMatchNavigationItem';
import { useAccountNavigationItem } from './useAccountNavigationItem';
import { useAssistNavigationItem } from './useAssistNavigationItem';
import { useLeagueNavigationItem } from './useLeagueNavigationItem';
import { useTacticsNavigationItem } from './useTacticsNavigationItem';
import { useThreeSixtyNavigationItem } from './useThreeSixtyNavigationItem';
import { useExploreNavigationItem } from './useExploreNavigationItem';

export const useCrossPlatformNavigationItems = () => {
  const { t } = useTranslation('navigation');
  const setSelectedNavAtom = useSetAtom(selectedNavigationAtom);

  const navigationItems: { primary: NavigationItem[]; footer: NavigationItem[] } = {
    primary: [
      useVideoPlaylistNavigationItem(),
      usePlayerNavigationItem(true),
      useKeeperNavigationItem(),
      useTeamNavigationItem(),
      useMatchNavigationItem(),
      useLeagueNavigationItem(),
      useTacticsNavigationItem(),
      useExploreNavigationItem(),
      useThreeSixtyNavigationItem(),
    ],
    footer: [
      useAssistNavigationItem(),
      useAccountNavigationItem(),
      {
        id: 'switch-nav',
        icon: 'Swap',
        onClick: () => setSelectedNavAtom('singlePlatform'),
        label: t('primary.switchNav'),
      },
    ],
  };
  return navigationItems;
};
